jQuery(document).ready(function ($) {
  // Add class to the navbar on scroll
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    var limit = window.innerHeight / 2;
    var navbar = $(".navbar");
    var isHome = document.body.classList.contains("home");

    // Manipulate classes on scroll
    if (scroll >= limit) {
      navbar.addClass("navbar--shadow");
      if (isHome) navbar.removeClass("navbar--transparent");
    } else {
      navbar.removeClass("navbar--shadow");
      if (isHome) navbar.addClass("navbar--transparent");
    }
  });

  // Toggle open/close navbar
  $(".navbar__toggler").click(function () {
    $(this).toggleClass("close");
    $(".navbar__navigation").toggleClass("open");
    $(".navbar").toggleClass("navbar--open");
    if ($(".navbar").hasClass("navbar--open")) {
      const open = $(".navbar__navigation-menu").find(".sub-menu.open");
      open.slideUp().removeClass(".open");
    }
  });

  // Toggle dropdown menu
  $(".navbar__navigation-menu .menu-item-has-children>a").click(function (e) {
    e.preventDefault();
    const dropdown = $(this).parent().find(".sub-menu");
    const open = $(".navbar__navigation-menu").find(".sub-menu.open");
    open.not(dropdown).slideUp().removeClass(".open");
    $(dropdown).addClass("open");
    $(dropdown).slideDown();
  });

  // Toggle search form
  $(".navbar__actions-search").click(function () {
    $(this).toggleClass("close");
    if ($(this).hasClass("close")) {
      $(this).find(".navbar__actions-icon").html("close");
    } else {
      $(this).find(".navbar__actions-icon").html("search");
    }
    $(".navbar__actions-search-form").toggleClass("open").toggle(500, "swing");
    $("input[type=search].dgwt-wcas-search-input").focus();
  });
});
